import React from "react";

export const Group = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M18.4281 7.79579C18.4281 10.1626 16.5094 12.0813 14.1425 12.0813C11.7757 12.0813 9.85702 10.1626 9.85702 7.79579C9.85702 5.42895 11.7757 3.51025 14.1425 3.51025C16.5094 3.51025 18.4281 5.42895 18.4281 7.79579Z"
        fill="#52B9F3"
      />
      <path
        d="M20.9996 16.6968C20.9996 18.8945 17.9296 19.7736 14.1427 19.7736C10.3558 19.7736 7.28586 18.8945 7.28586 16.6968C7.28586 14.7219 10.3558 13.62 14.1427 13.62C17.9296 13.62 20.9996 14.4991 20.9996 16.6968Z"
        fill="#52B9F3"
      />
      <path
        d="M14.1422 9.53245C14.1422 11.8993 12.2235 13.818 9.85669 13.818C7.48986 13.818 5.57116 11.8993 5.57116 9.53245C5.57116 7.16562 7.48986 5.24692 9.85669 5.24692C12.2235 5.24692 14.1422 7.16562 14.1422 9.53245Z"
        fill="#3448FF"
      />
      <path
        d="M16.7137 18.4335C16.7137 20.6312 13.6438 21.5103 9.85685 21.5103C6.06992 21.5103 3 20.6312 3 18.4335C3 16.4586 6.06992 15.3567 9.85685 15.3567C13.6438 15.3567 16.7137 16.2358 16.7137 18.4335Z"
        fill="#3448FF"
      />
    </svg>
  );
};
